import { getTvObject, tv } from '@costar-ui/cosmos';

var variant = getTvObject({
  'neutral-subtle': 'border-neutral-subtle',
  neutral: 'border-neutral',
  'neutral-moderate': 'border-neutral-moderate',
  base: 'border-base',
  'base-inverse': 'border-base-inverse',
  'rounded-subtle': ['border-accent-highlight-subtle', 'rounded-sm', 'border-r-4'],
  'rounded-bold': ['border-accent-highlight-bold', 'rounded-sm', 'border-r-4'],
  'rounded-strong': ['border-accent-highlight-strong', 'rounded-sm', 'border-r-4']
});
var dividerTV = getTvObject({
  variants: {
    direction: {
      vertical: ['border-r'],
      horizontal: ['w-full', 'border-t']
    },
    variant: variant,
    fullHeight: {
      "true": 'h-full'
    },
    absolute: {
      "true": ['absolute bottom-0 left-0 w-full']
    }
  },
  compoundVariants: [
  // only set height on vertical divider if not fullHeight (flex)
  {
    direction: 'vertical',
    fullHeight: false,
    className: 'h-e-1.0'
  }]
});
var base = tv(dividerTV);
var dividerStyles = {
  base: base
};

export { dividerStyles, dividerTV };
//# sourceMappingURL=divider.styles.esm.js.map
